import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  receiverUser: "",
  amount: "",
  sendID: "",
  receiverUserType: "",
};

export const withDrawSlice = createSlice({
  name: "withDraw",
  initialState,
  reducers: {
    setWithDrawData: (state, action) => {
      const { receiverUser, amount, sendID, receiverUserType } = action.payload;
      state.receiverUser = receiverUser; // Corrected this line
      state.amount = amount;
      state.sendID = sendID;
      state.receiverUserType = receiverUserType;
    },
  },
});

export const { setWithDrawData } = withDrawSlice.actions;

export default withDrawSlice.reducer;
